<topo-modal
  [isActive]="!!userProfile && isReady"
  id="user-profile-modal"
  [isCard]="true">
  <div class="modal-header">
    <div
      class="mx-4 my-4"
      fxLayout="row"
      fxLayoutAlign="space-between">
      <div>
        @if (isReady && !showPasswordFields) {
          <h5>{{ 'MANAGEMENT.USERS.EDIT_PROFILE' | translate }}</h5>
        }
        @if (isReady && showPasswordFields) {
          <h5>{{ 'MANAGEMENT.USERS.CHANGE_PASSWORD' | translate }}</h5>
        }
      </div>
      <div>
        <div
          class="dialog-close"
          (click)="onClose()">
          <i class="icon icon-close-X"></i>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-body">
    @if (isReady && !showPasswordFields) {
      <form
        [formGroup]="profileForm"
        (ngSubmit)="onSubmit(profileForm)"
        class="is-relative">
        <div fxLayout="row">
          <div style="width: 350px">
            <section class="field">
              <label>{{ 'MANAGEMENT.USERS.FULL_NAME' | translate }}</label>
              <div>
                <input
                  class="input"
                  type="text"
                  placeholder="{{ 'MANAGEMENT.USERS.FULL_NAME' | translate }}"
                  formControlName="fullName" />
              </div>
            </section>
            <section class="field">
              <label>{{ 'MANAGEMENT.USERS.DISPLAY_NAME' | translate }}</label>
              <div>
                <input
                  class="input"
                  type="text"
                  placeholder="{{ 'MANAGEMENT.USERS.DISPLAY_NAME' | translate }}"
                  formControlName="displayName" />
              </div>
            </section>
            <section class="field">
              <label>{{ 'MANAGEMENT.USERS.EMAIL_READ_ONLY' | translate }}</label>
              <div>
                <input
                  class="input is-readonly"
                  readonly
                  type="text"
                  placeholder="{{ 'MANAGEMENT.USERS.EMAIL' | translate }}"
                  formControlName="emailAddress" />
              </div>
            </section>
            <section class="field">
              <label>{{ 'MANAGEMENT.USERS.PHONE' | translate }}</label>
              <div fxLayout="row">
                @let phoneControl = profileForm.get('phoneNumber');
                <topo-phone-input
                  [formControl]="phoneControl"
                  dropdownContainerId="user-profile-modal__portal-outlet"
                  [showErrorState]="phoneControl.dirty && phoneControl.touched" />
              </div>
            </section>
            <section class="field">
              <label>{{ 'MANAGEMENT.ORGANIZATIONS.LANGUAGE' | translate }}</label>
              <div>
                <div class="select is-primary">
                  <select
                    class="small-select-font"
                    formControlName="cultureCode">
                    @for (lang of languages; track lang.cultureCode) {
                      <option [ngValue]="lang.cultureCode">
                        {{ getLanguageDisplay(lang) }}
                      </option>
                    }
                  </select>
                </div>
              </div>
            </section>
            <section class="field">
              <label>{{ 'MANAGEMENT.USERS.DISTANCE_UNITS' | translate }}</label>
              <div>
                <div class="select is-primary is-fullwidth">
                  <select
                    class="small-select-font"
                    formControlName="distanceUnit">
                    @for (ac of supportedUnits; track ac) {
                      <option [ngValue]="ac">
                        {{ 'UNITS.DISTANCE.' + ac | translate }}
                      </option>
                    }
                  </select>
                </div>
              </div>
            </section>
            <section class="field">
              <label>{{ 'MANAGEMENT.USERS.TIMEZONE' | translate }}</label>
              <div>
                <ng-select
                  [items]="timezones"
                  [clearable]="clearable"
                  [virtualScroll]="virtualScroll"
                  [groupBy]="'group'"
                  bindLabel="name"
                  appendTo=".modal"
                  formControlName="timezone"
                  class="custom"></ng-select>
              </div>
            </section>
            <section class="field">
              <div
                fxLayout="row"
                fxLayoutAlign="space-between center">
                <label class="radio">{{ 'MANAGEMENT.USERS.USE-24H' | translate }}</label>
                <topo-switch formControlName="use24HTime"></topo-switch>
              </div>
            </section>
            @if (changePassword) {
              <section class="field">
                <label>{{ 'MANAGEMENT.USERS.CHANGE_PASSWORD' | translate }}</label>
                <div>
                  <button
                    type="button"
                    class="button is-secondary"
                    (click)="onChangePassword()">
                    {{ 'MANAGEMENT.USERS.CHANGE_PASSWORD' | translate }}
                  </button>
                </div>
              </section>
            }
          </div>
          <div class="ml-6">
            <div
              fxLayout="row"
              fxLayoutAlign="center center">
              <topo-avatar
                [name]="profileForm.get('displayName')?.value || profileForm.get('emailAddress')?.value"
                [imageUrl]="profileForm.get('profilePhotoUrl')?.value"
                [size]="100"
                [fontSize]="30"></topo-avatar>
            </div>
            <div
              fxLayout="row"
              fxLayoutAlign="center center"
              class="mt-3">
              <input
                #photo
                class="file-input"
                type="file"
                id="photo"
                (change)="fileChangeEvent($event)"
                accept="image/*" />
              <button
                type="button"
                class="button is-secondary is-small"
                (click)="changePhoto()">
                {{ 'MANAGEMENT.USERS.CHANGE-PHOTO' | translate }}
              </button>
            </div>
            <div class="mt-6">
              <button
                type="button"
                class="button is-primary"
                (click)="openNotificationPrefs()">
                {{ 'MANAGEMENT.USERS.NOTIFICATION-PREFS' | translate }}
              </button>
            </div>
          </div>
          <div>
            <topo-modal [isActive]="isEditingPhoto">
              <div class="mx-4 my-4">
                <div
                  fxLayout="row wrap"
                  fxLayoutGap="20px">
                  <div fxFlex>
                    <image-cropper
                      [imageFile]="imageFile"
                      [maintainAspectRatio]="true"
                      [resizeToWidth]="128"
                      [cropperMinWidth]="128"
                      [onlyScaleDown]="true"
                      [roundCropper]="true"
                      format="png"
                      output="base64"
                      (imageCropped)="imageCropped($event)"
                      (imageLoaded)="imageLoaded()"
                      (cropperReady)="cropperReady()"
                      (loadImageFailed)="loadImageFailed()"></image-cropper>
                  </div>
                  <div
                    fxFlex="128px"
                    fxLayout="column"
                    fxLayoutAlign="center center"
                    fxLayoutGap="20px">
                    <img
                      style="border-radius: 100%"
                      [src]="croppedImage" />
                    <img
                      style="border-radius: 100%; width: 60px; height: 60px"
                      [src]="croppedImage" />
                    <img
                      style="border-radius: 100%; width: 40px; height: 40px"
                      [src]="croppedImage" />
                  </div>
                  <div
                    fxFlex="100"
                    fxLayoutAlign="center center"
                    fxLayoutGap="10px"
                    class="md-margin-top">
                    <button
                      type="button"
                      class="button is-secondary"
                      (click)="closeImageCropper()">
                      {{ 'MANAGEMENT.USERS.CANCEL' | translate }}
                    </button>
                    <button
                      type="button"
                      class="button is-primary"
                      (click)="updatePhoto()">
                      {{ 'MANAGEMENT.USERS.UPDATE-PHOTO' | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </topo-modal>
          </div>
        </div>
      </form>
    }

    @if (isReady && showPasswordFields) {
      <form
        [formGroup]="passwordForm"
        (ngSubmit)="onPwSubmit(passwordForm)"
        class="is-relative">
        <section class="field">
          <label>{{ 'MANAGEMENT.USERS.CURRENT_PASSWORD' | translate }}</label>
          <div>
            <input
              class="input"
              type="password"
              placeholder="{{ 'MANAGEMENT.USERS.CURRENT_PASSWORD' | translate }}"
              autocomplete="current-password"
              formControlName="currentPassword" />
          </div>
        </section>
        <section class="field">
          <label>{{ 'MANAGEMENT.USERS.NEW_PASSWORD' | translate }}</label>
          <div>
            <input
              class="input"
              type="password"
              placeholder="{{ 'MANAGEMENT.USERS.NEW_PASSWORD' | translate }}"
              autocomplete="new-password"
              formControlName="newPassword" />
          </div>
        </section>
        <section class="field">
          <label>{{ 'MANAGEMENT.USERS.CONFIRM_PASSWORD' | translate }}</label>
          <div>
            <input
              class="input"
              type="password"
              placeholder="{{ 'MANAGEMENT.USERS.CONFIRM_PASSWORD' | translate }}"
              autocomplete="new-password"
              formControlName="passwordConfirm" />
          </div>
        </section>
        <h5>{{ 'PASSWORD-POLICY.POLICY' | translate }}</h5>
        <div>
          <ul class="policy_list">
            <li
              [ngClass]="{
                error:
                  (passwordForm.get('newPassword').touched || passwordForm.get('newPassword').dirty) &&
                  passwordForm?.get('newPassword').errors?.minlength
              }">
              {{ 'PASSWORD-POLICY.POLICY-LENGTH' | translate }}
            </li>
            <li
              [ngClass]="{
                error:
                  (passwordForm.get('newPassword').touched || passwordForm.get('newPassword').dirty) &&
                  passwordForm?.get('newPassword').errors?.specialCharacterValid
              }">
              {{ 'PASSWORD-POLICY.POLICY-SPECIAL' | translate }}
            </li>
            <li
              [ngClass]="{
                error:
                  (passwordForm.get('newPassword').touched || passwordForm.get('newPassword').dirty) &&
                  passwordForm.get('newPassword').errors?.passwordStrength
              }">
              {{ 'PASSWORD-POLICY.POLICY-CHARS' | translate }}
            </li>
            @if (!passwordForm.errors?.passwordMatchError && passwordForm.errors?.passwordReused) {
              <li class="error">
                {{ 'PASSWORD-POLICY.POLICY-PASSWORD-REUSE' | translate }}
              </li>
            }
            @if (passwordForm.errors?.passwordMatchError) {
              <li class="error">
                {{ 'PASSWORD-POLICY.POLICY-PASSWORD-MATCH' | translate }}
              </li>
            }
          </ul>
        </div>
      </form>
    }
  </div>

  <div class="modal-footer">
    @if (isReady && !showPasswordFields) {
      <section
        class="field buttons mt-4"
        fxLayout="row"
        fxLayoutAlign="end">
        <button
          type="button"
          class="button is-secondary mr-2"
          (click)="onClose()">
          {{ 'MANAGEMENT.USERS.CANCEL' | translate }}
        </button>
        <button
          type="button"
          [disabled]="!profileForm.valid"
          class="button is-primary"
          (click)="onSubmit(profileForm, true)">
          {{ 'MANAGEMENT.USERS.SAVE' | translate }}
        </button>
      </section>
    }

    @if (isReady && showPasswordFields) {
      <section
        class="field buttons mt-4"
        fxLayout="row"
        fxLayoutAlign="end">
        <button
          type="button"
          class="button is-secondary mr-2"
          (click)="onBack()">
          {{ 'MANAGEMENT.USERS.BACK' | translate }}
        </button>
        <button
          type="button"
          [disabled]="!passwordForm.valid"
          class="button is-primary"
          (click)="onPwSubmit(passwordForm)">
          {{ 'MANAGEMENT.USERS.SAVE' | translate }}
        </button>
      </section>
    }
  </div>
</topo-modal>
